import { render, staticRenderFns } from "./Welcome.vue?vue&type=template&id=5ac13be2&scoped=true&"
import script from "./Welcome.vue?vue&type=script&lang=js&"
export * from "./Welcome.vue?vue&type=script&lang=js&"
import style0 from "./Welcome.vue?vue&type=style&index=0&id=5ac13be2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac13be2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ac13be2')) {
      api.createRecord('5ac13be2', component.options)
    } else {
      api.reload('5ac13be2', component.options)
    }
    module.hot.accept("./Welcome.vue?vue&type=template&id=5ac13be2&scoped=true&", function () {
      api.rerender('5ac13be2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/messages/Welcome.vue"
export default component.exports